<template>
  <div>
    <div class="passport" v-if="display">
      <div class="mask"></div>
      <!-- 免密登录 -->
      <div class="passport-box" v-if="loginType == 1">
        <div class="hd">免密登录</div>
        <div class="bd">
          <form class="passport-form">
            <div class="passport-form-item passport-ipt-item">
              <input
                type="text"
                class="ipt"
                id="mobile"
                v-model="form.phone"
                placeholder="请输入手机号"
                @blur="handleValid"
              />
            </div>
            <div class="passport-form-item-error" v-show="errPhone">
              {{ errMsgPhone }}
            </div>
            <div class="passport-form-item passport-ipt-item passport-yzm-tem">
              <input
                type="text"
                class="ipt ipt-yzm"
                id="yzm"
                maxlength="6"
                v-model="form.captcha"
                @blur="handleValid"
                placeholder="请输入验证码"
              /><button
                type="button"
                class="btn-yzm"
                @click="handleGetCaptcha"
                v-if="toggleCaptcha"
              >
                获取验证码
              </button>
              <button type="button" class="btn-yzm disabled" v-else>
                重新发送({{ time }})
              </button>
            </div>
            <div class="passport-form-item-error" v-show="errCaptcha">
              验证码不能为空
            </div>
            <div class="passport-form-item">
              <label
                ><input
                  type="checkbox"
                  class="check"
                  checked=""
                  v-model="rememberMe"
                /><span>两周内自动登录</span></label
              ><a href="javascript:void(0)" @click="handleRestPassword"
                >忘记密码？</a
              >
            </div>
            <div class="passport-form-item">
              <button
                type="button"
                class="btn btn-login"
                :class="{ disabled }"
                @click="handleLogin"
              >
                登录
              </button>
            </div>
          </form>
          <div class="passport-form-bottom">
            <div class="passport-form-item">
              <a href="javascript:void(0)" @click="handleToggleLogin(2)"
                >密码登录</a
              ><a href="javascript:void(0)" @click="handleToggleLogin(4)"
                >注册新账号</a
              >
            </div>
            <div class="passport-form-item item-w">
              <div class="hd-break"><span>其他登录方式</span></div>
              <a href="javascript:;" class="weixin-login"
                ><i class="icon-weixin"></i>微信登录</a
              >
            </div>
          </div>
        </div>
        <a
          class="close btn-ppclose"
          href="javascript:void(0)"
          @click="display = false"
        ></a>
      </div>
      <!-- 密码登录 -->
      <div class="passport-box" v-if="loginType == 2">
        <div class="hd">密码登录</div>
        <div class="bd">
          <form class="passport-form">
            <div class="passport-form-item passport-ipt-item">
              <input
                type="text"
                class="ipt"
                id="mobile"
                v-model="form.phone"
                placeholder="请输入手机号"
                @blur="handleValid"
              />
            </div>
            <div class="passport-form-item-error" v-show="errPhone">
              {{ errMsgPhone }}
            </div>
            <div class="passport-form-item passport-ipt-item">
              <input
                type="password"
                class="ipt"
                id="password"
                placeholder="请输入密码"
                v-model="form.password"
                @blur="handleValid"
              />
            </div>
            <div class="passport-form-item-error" v-show="errPassword">
              密码码不能为空
            </div>
            <div class="passport-form-item">
              <label
                ><input
                  type="checkbox"
                  class="check"
                  v-model="rememberMe"
                /><span>两周内自动登录</span></label
              ><a href="javascript:void(0)" @click="handleRestPassword"
                >忘记密码？</a
              >
            </div>
            <div class="passport-form-item">
              <button
                type="button"
                class="btn btn-login"
                :class="{ disabled }"
                @click="handleLogin"
              >
                登录
              </button>
            </div>
          </form>
          <div class="passport-form-bottom">
            <div class="passport-form-item">
              <a href="javascript:void(0)" @click="handleToggleLogin(1)"
                >免密登录</a
              ><a href="javascript:void(0)" @click="handleToggleLogin(4)"
                >注册新账号</a
              >
            </div>
            <div class="passport-form-item item-w">
              <div class="hd-break"><span>其他登录方式</span></div>
              <a href="javascript:;" class="weixin-login"
                ><i class="icon-weixin"></i>微信登录</a
              >
            </div>
          </div>
        </div>
        <a
          class="close btn-ppclose"
          href="javascript:void(0)"
          @click="display = false"
        ></a>
      </div>
      <!-- 注册 -->
      <div class="passport-box" v-if="loginType == 4">
        <div class="hd">注册账号</div>
        <div class="bd">
          <form class="passport-form passport-regForm">
            <div class="passport-form-item passport-ipt-item">
              <input
                type="text"
                class="ipt"
                id="mobile"
                placeholder="请输入手机号"
                v-model="form.phone"
                @blur="handleValid"
              />
            </div>
            <div class="passport-form-item-error" v-show="errPhone">
              {{ errMsgPhone }}
            </div>
            <div class="passport-form-item passport-ipt-item passport-yzm-tem">
              <input
                type="text"
                class="ipt ipt-yzm"
                id="yzm"
                maxlength="6"
                placeholder="请输入验证码"
                v-model="form.captcha"
                @blur="handleValid"
              />
              <button
                type="button"
                class="btn-yzm"
                @click="handleGetCaptcha"
                v-if="toggleCaptcha"
              >
                获取验证码
              </button>
              <button type="button" class="btn-yzm disabled" v-else>
                重新发送({{ time }})
              </button>
            </div>
            <div class="passport-form-item-error" v-show="errCaptcha">
              验证码不能为空
            </div>
            <div class="passport-form-item passport-ipt-item">
              <input
                type="password"
                class="ipt"
                id="password"
                placeholder="设置密码 6-12位字母/数字/符号"
                v-model="form.password"
                @blur="handleValid"
              />
            </div>
            <div class="passport-form-item-error" v-show="errPassword">
              密码码不能为空
            </div>
            <div class="passport-form-item">
              <label
                ><input
                  type="checkbox"
                  class="check"
                  id="agreement"
                  value="1"
                  checked=""
                /><span>我已阅读并接受</span
                ><a
                  class="o"
                  href="javascript:void(0);"
                  @click="handleToggleLogin(5)"
                  >《千途网服务协议》</a
                ></label
              >
            </div>
            <div class="passport-form-item">
              <button
                type="button"
                class="btn btn-reg"
                :class="{ disabled }"
                @click="handleRegister"
              >
                同意协议并注册
              </button>
            </div>
          </form>
          <div class="passport-form-bottom">
            <div class="passport-form-item item-c">
              <span>已有账号，</span
              ><a
                class="o"
                href="javascript:void(0)"
                @click="handleToggleLogin(2)"
                >马上登录</a
              >
            </div>
          </div>
        </div>
        <a
          class="close btn-ppclose"
          href="javascript:void(0)"
          @click="display = false"
        ></a>
      </div>
      <!-- 使用协议 -->
      <div class="passport-box" v-if="loginType == 5">
        <div class="hd">千途使用协议v1.0</div>
        <div class="bd">
          <div class="passport-agreement-form">
            <p>特别提示</p>
            <p>
              福州全摄汇网络科技有限公司(以下简称“千途”)在此特别提醒您(以下或称“用户”)在注册成为用户之前,请认真阅读本《用户协议》(以下简称“协议”),以确保您充分理解本协议中各条款。您的注册、登录、使用等行为将视为对本协议的接受,并同意接受本协议各项条款的约束。
            </p>
            <p>
              本协议约定千途与用户之间关于“千途”软件服务的权利义务。“用户”是指注册、登录、使用本服务的个人。本协议可由千途随时更新,更新后的协议条款一旦公布即代替原来的协议条款,恕不再另行通知,用户可在本网站查阅最新版协议条款。在修改协议条款后,如果用户不接受修改后的条款,请立即停止使用千途提供的服务,用户继续使用千途提供的服务将被视为接受修改后的协议。此外，千途对本协议拥有最终的解释权。
            </p>
            <p>一、帐号注册</p>
            <p>
              1、用户在使用本服务前需要注册一个“千途”帐号。“千途”帐号应当使用手机号码绑定注册,请用户使用尚未与“千途”帐号绑定的手机号码,以及未被千途根据本协议封禁的手机号码注册“千途”帐号。千途可以根据用户需求或产品需要对帐号注册和绑定的方式进行变更,而无须事先通知用户。
            </p>
            <p>
              3、鉴于“千途”帐号的绑定注册方式,您同意千途在注册时将使用您提供的手机号码及/或自动提取您的手机号码及自动提取您的手机设备识别码等信息用于注册。
            </p>
            <p>
              4、在用户注册及使用本服务时,千途需要搜集能识别用户身份的个人信息以便千途可以在必要时联系用户,为用户提供更好的使用体验。千途搜集的信息包括但不限于用户的性别、年龄、出生日期、个人说明及法律法规规定的必要身份信息，用户应确保信息的真实性、合法性、有效性，如用户提交的信息不完整或不符合法律法规的规定,则用户可能无法使用本服务或在使用本服务的过程中受到限制。
            </p>
            <p>
              千途同意对这些信息的使用将受限于第三条用户个人隐私信息保护的约束。
            </p>
            <p>二、服务内容</p>
            <p>
              1、服务的具体内容由千途根据实际情况提供,包括但不限于授权用户通过其帐号进行即时通讯、添加好友、加入群组、发布留言等。千途可以对其提供的服务予以变更,且千途提供的服务内容可能随时变更;用户将会收到千途关于服务变更的通知。
            </p>
            <p>
              2、千途提供的服务均为免费服务,若后期增加收费服务功能,将另行通知。
            </p>
            <p>三、用户个人隐私信息保护</p>
            <p>
              1、个人隐私信息是指涉及用户个人身份或个人隐私的信息,比如,用户真实姓名、身份证号、手机号码、手机设备识别码、IP地址、用户聊天记录。非个人隐私信息是指用户对本服务的操作状态以及使用习惯等明确且客观反映在千途服务器端的基本记录信息、个人隐私信息范围外的其它普通信息,以及用户同意公开的上述隐私信息。
            </p>
            <p>
              2、尊重用户个人隐私信息是千途的一贯制度,千途将采取技术措施和其他必要措施,确保用户个人隐私信息安全,防止在本服务中收集的用户个人隐私信息泄露、毁损或丢失。在发生或者发现可能存在前述情形时,千途将及时采取补救措施。
            </p>
            <p>
              3、千途未经用户同意不向任何第三方公开、透露用户个人隐私信息。但以下特定情形除外:
            </p>
            <p>
              (1) 千途根据法律法规规定或有权机关的指示提供用户的个人隐私信息;
            </p>
            <p>
              (2)
              由于用户将其用户密码告知他人或与他人共享注册帐户与密码,由此导致的任何个人信息的泄漏,或其他非因千途原因导致的个人隐私信息的泄露;
            </p>
            <p>(3) 用户自行向第三方公开其个人隐私信息;</p>
            <p>
              (4)
              用户与千途及合作单位之间就用户个人隐私信息的使用公开达成约定,千途因此向合作单位公开用户个人隐私信息;
            </p>
            <p>
              (5)
              任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人隐私信息的泄露。
            </p>
            <p>4、用户同意千途可在以下事项中使用用户的个人隐私信息:</p>
            <p>(1) 千途向用户及时发送重要通知,如软件更新、本协议条款的变更;</p>
            <p>
              (2)
              千途内部进行审计、数据分析和研究等,以改进产品、服务和与用户之间的沟通;
            </p>
            <p>(3) 依本协议约定,千途管理、审查用户信息及进行处理措施;</p>
            <p>(4) 适用法律法规规定的其他事项。</p>
            <p>
              除上述事项外,如未取得用户事先同意,千途不会将用户个人隐私信息使用于任何其他用途。
            </p>
            <p>
              5、千途重视对未成年人个人隐私信息的保护。千途将依赖用户提供的个人信息判断用户是否为未成年人。任何18岁以下的未成年人注册帐号或使用本服务应事先取得家长或其法定监护人(以下简称"监护人")的书面同意。除根据法律法规的规定及有权机关的指示披露外,千途不会使用或向任何第三方透露未成年人的聊天记录及其他个人隐私信息。除本协议约定的例外情形外,未经监护人事先同意,千途不会使用或向任何第三方透露未成年人的个人隐私信息。除满足前述条件外，任何18岁以下的用户不得下载和使用千途所提供的软件服务。
            </p>
            <p>
              6、用户确认,其地理位置信息为非个人隐私信息,用户成功注册“千途”帐号视为确认授权千途提取、公开及使用用户的地理位置信息。用户地理位置信息将作为用户公开资料之一,由千途向其他用户公开。如用户需要终止向其他用户公开其地理位置信息,可随时退出软件服务。
            </p>
            <p>
              7、为了改善千途的技术和服务,向用户提供更好的服务体验,千途或可会自行收集使用或向第三方提供用户的非个人隐私信息。
            </p>
            <p>四、内容规范</p>
            <p>
              1、本条所述内容是指用户使用本服务过程中所制作、上载、复制、发布、传播的任何内容,包括但不限于帐号头像、名称、用户说明等注册信息及认证资料,或文字、语音、图片、视频、游记等发送、回复或自动回复消息和相关链接页面,以及其他使用帐号或本服务所产生的内容。
            </p>
            <p>
              2、用户不得利用“千途”帐号或本服务制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容:
            </p>
            <p>(1) 反对宪法所确定的基本原则的;</p>
            <p>(2) 危害国家安全,泄露国家秘密,颠覆国家政权,破坏国家统一的;</p>
            <p>(3) 损害国家荣誉和利益的;</p>
            <p>(4) 煽动民族仇恨、民族歧视,破坏民族团结的;</p>
            <p>(5) 破坏国家宗教政策,宣扬邪教和封建迷信的;</p>
            <p>(6) 散布谣言,扰乱社会秩序,破坏社会稳定的;</p>
            <p>(7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;</p>
            <p>(8) 侮辱或者诽谤他人,侵害他人合法权益的;</p>
            <p>(9) 不遵守道德风尚要求的;</p>
            <p>(10) 含有法律、行政法规禁止的信息。</p>
            <p>
              3、用户不得利用“千途”帐号或本服务制作、上载、复制、发布、传播如下干扰“千途”正常运营,以及侵犯其他用户或第三方合法权益的内容:
            </p>
            <p>(1) 含有任何性或性暗示的;</p>
            <p>(2) 含有辱骂、恐吓、威胁内容的;</p>
            <p>(3) 含有骚扰、垃圾广告、恶意信息、诱骗信息的;</p>
            <p>(4) 涉及他人隐私、个人信息或资料的;</p>
            <p>(5) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的;</p>
            <p>
              (6)
              含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。
            </p>
            <p>五、使用规则</p>
            <p>
              1、用户在使用千途或通过千途所传送、发布的任何内容并不反映或代表,也不得被视为反映或代表千途的观点、立场或政策,千途对此不承担任何责任。
            </p>
            <p>2、用户不得利用“千途”帐号或本服务进行如下行为:</p>
            <p>
              (1) 提交、发布虚假信息,或盗用他人头像或资料,冒充、利用他人名义的;
            </p>
            <p>(2) 强制、诱导其他用户关注、点击链接页面或分享信息的;</p>
            <p>(3) 虚构事实、隐瞒真相以误导、欺骗他人的;</p>
            <p>(4) 利用技术手段批量建立虚假帐号的;</p>
            <p>(5) 利用“千途”帐号或本服务从事任何违法犯罪活动的;</p>
            <p>
              (6)
              制作、发布与以上行为相关的方法、工具,或对此类方法、工具进行运营或传播,无论这些行为是否为商业目的;
            </p>
            <p>
              (7)
              其他违反法律法规规定、侵犯其他用户合法权益、干扰“千途”正常运营的行为。
            </p>
            <p>
              3、用户须对利用“千途”帐号传送信息的真实性、合法性、无害性、准确性、有效性等全权负责,与用户所传播的信息相关的任何法律责任由用户自行承担,与千途无关。如因此给千途或第三方造成损害的,用户应自行承担由此产生的责任，并予以赔偿。
            </p>
            <p>
              4、千途提供的服务中可能包括广告,用户同意在使用过程中显示千途和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外,用户应自行对依该广告信息进行的交易负责,对用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害,千途不承担任何责任。
            </p>
            <p>六、账户管理</p>
            <p>
              1、“千途”帐号的所有权归千途所有,用户完成申请注册手续后,获得“千途”帐号的使用权,该使用权仅属于初始申请注册人,禁止赠与、借用、租用、转让或售卖。千途因经营需要,有权回收用户的“千途”帐号。
            </p>
            <p>
              2、用户可以更改、删除“千途”帐户上的个人资料、注册信息及传送内容等,但需注意,删除有关信息的同时也会删除用户储存在系统中的文字和图片,用户需承担该风险。
            </p>
            <p>
              3、用户有责任妥善保管注册帐号信息及帐号密码,且用户须对注册账号的所有行为和事件承担法律责任。因用户保管不善可能遭受盗号或密码失窃等风险,责任由用户自行承担。用户同意在任何情况下不使用其他用户的帐号或密码。在用户怀疑他人使用其帐号或密码时,用户同意立即通知千途。
            </p>
            <p>
              4、用户应遵守本协议的各项条款,正确、适当地使用本服务,如因用户违反本协议中的任何条款,千途在通知用户后有权依据协议中断或终止对违约用户“千途”帐号提供服务。同时,千途保留在任何时候收回“千途”帐号、用户名的权利。
            </p>
            <p>
              5、如用户注册“千途”帐号后一年不登录,通知用户后,千途可以收回该帐号,以免造成资源浪费,由此造成的不利后果由用户自行承担。
            </p>
            <p>七、数据储存</p>
            <p>1、千途不对用户在本服务中相关数据的删除或储存失败负责。</p>
            <p>
              2、千途可以根据实际情况自行决定用户在本服务中数据的最长储存期限,并在服务器上为其分配数据最大存储空间等。用户可根据自己的需要自行备份本服务中的相关数据。
            </p>
            <p>
              3、如用户停止使用千途或千途终止提供服务的,千途可以从服务器上永久地删除用户的数据,且千途没有义务向用户返还任何数据。
            </p>
            <p>八、风险承担</p>
            <p>
              1、用户理解并同意,“千途”仅为用户提供信息分享、传送及获取的平台,用户必须为自己注册帐号下的一切行为负责,包括用户所传送的任何内容以及由此产生的任何后果。用户应对“千途”及本服务中的内容自行加以判断,并承担因使用内容而引起的所有风险,包括因对内容的正确性、完整性或实用性的依赖而产生的风险。千途无法且不会对因用户行为而导致的任何损失或损害承担责任。
            </p>
            <p>
              如果用户发现任何人违反本协议约定或以其他不当的方式使用千途的,请立即向千途举报或投诉,千途将依本协议约定进行处理。
            </p>
            <p>
              2、用户理解并同意,因业务发展需要,千途保留单方面对千途提供的服务内容进行全部或部分变更、暂停、终止或撤销的权利,用户需承担此风险。
            </p>
            <p>九、知识产权声明</p>
            <p>
              1、千途在服务中提供的内容(包括但不限于网页、文字、图片、音频、视频、图表等)的知识产权均归千途或相关权利人所有。除另有特别声明外,千途提供服务时依托软件的著作权、专利权及其他知识产权均归千途或相关权利人所有。
            </p>
            <p>
              千途在提供服务中所涉及的图形、文字或其组成,以及其他千途标志及产品、服务名称(以下统称“千途标识”),其著作权或商标权归千途所有。未经千途事先书面同意,用户不得将千途标识以任何方式展示或使用或作其他处理,也不得向他人表明用户有权展示、使用或其他有权处理千途标识的行为。
            </p>
            <p>
              上述及其他任何千途或相关权利人依法拥有的知识产权均受到法律保护,未经千途或相关权利人书面许可,用户不得以任何形式进行使用或创造相关衍生作品。
            </p>
            <p>
              2、千途同样尊重用户的知识产权，并承诺将保护用户的知识产权作为千途运营的基本原则之一。用户在千途上发表的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任意第三方的合法权益，如产生纠纷，与千途无关，如因此造成千途损失（包括但不限于经济、商誉等），用户应予以赔偿。用户在千途上发表内容不作为用户或相关权利人放弃对该内容的权利。此外，用户可授权任意第三方使用该内容，而无需得到千途的同意。
            </p>
            <p>
              3、针对用户的恶意评论、侵犯知识产权等行为，经举报，千途会依法或依本协议采取措施，但不保证能够满足用户的需求，也不对侵权承担任何责任，用户对此知悉并同意。
            </p>
            <p>
              4、用户同意授予千途所发表内容在全球范围内的免费、不可撤销的、永久的、可再许可或转让的使用权许可，据该许可千途有权以展示、推广及其他不为法律所禁止的方式使用用户发表的内容。如因用户发表他人知识产权内容而未标明，导致千途根据本条款使用用户发表内容被追责的，用户应承担全部责任。
            </p>
            <p>十、法律责任</p>
            <p>
              1、如果千途发现或收到他人举报或投诉用户违反本协议约定的,千途有权不经通知随时对相关内容,包括但不限于用户资料、聊天记录进行审查、删除,并视情节轻重对违规帐号处以包括但不限于警告、帐号封禁、设备封禁、功能封禁的处罚,且通知用户处理结果。
            </p>
            <p>
              2、用户理解并同意,千途有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚,对违法违规的任何用户采取适当的法律行动,并依据法律法规保存有关信息向有关部门报告等,用户应承担由此而产生的一切法律责任。
            </p>
            <p>
              3、用户理解并同意,因用户违反本协议约定,导致或产生的任何第三方主张的任何索赔、要求或损失,包括但不限于合理的律师费等,用户应当赔偿千途与合作公司、关联公司,使之免受损害，并承担由此引发的全部法律责任。
            </p>
            <p>十一、不可抗力及其他免责事由</p>
            <p>
              1、用户理解并确认,在使用千途的过程中,可能会遇到不可抗力等风险因素,使服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件,包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时,千途将努力在第一时间与相关单位配合,及时进行修复,但是由此给用户或第三方造成的损失,千途及合作单位依法免责。
            </p>
            <p>
              2、本服务同大多数互联网服务一样,受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响,可能受到各种安全问题的侵扰,如他人利用用户的资料,造成现实生活中的骚扰;用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒,威胁到用户的计算机信息和数据的安全,继而影响本服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识,要注意加强密码保护,以免遭致损失和骚扰。
            </p>
            <p>
              3、用户理解并确认,千途提供的服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险,因此导致的用户或第三方任何损失,千途不承担任何责任。
            </p>
            <p>
              4、用户理解并确认,在使用本服务过程中存在来自任何他人的包括误导性的、欺骗性的、威胁性的、诽谤性的、令人反感的或非法的信息,或侵犯他人合法权益的匿名或冒名的信息,以及伴随该等信息的行为,因此导致的用户或第三方的任何损失,千途不承担任何责任。
            </p>
            <p>
              5、用户理解并确认,千途需要定期或不定期地对“千途”平台或相关的设备进行检修或者维护,如因此类情况而造成服务在合理时间内的中断,千途无需为此承担任何责任。
            </p>
            <p>
              6、千途依据法律法规、本协议约定获得处理违法违规或违约内容的权利,该权利不构成千途的义务或承诺,千途不能保证及时发现违法违规或违约行为或进行相应处理。
            </p>
            <p>
              7、用户理解并确认,对于千途向用户提供的下列产品或者服务的质量缺陷及其引发的任何损失,千途无需承担任何责任:
            </p>
            <p>(1) 千途向用户免费提供的服务;</p>
            <p>(2) 千途向用户赠送的任何产品或者服务。</p>
            <p>
              8、用户发表的内容存在被其他用户复制、转载或做其他用途的风险，用户同意自行承担相应的责任；因用户使用千途服务而产生的一切后果也由用户自己承担，千途不对此承担任何责任。
            </p>
            <p>
              9、用户明确同意千途有权利用第三方合作平台对其发布的内容进行推广发布，千途的此种行为不属于对用户相关权益的侵权，千途无须承担任何责任。
            </p>
            <p>
              10、在任何情况下,千途均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害,包括因用户使用“千途”或本服务而遭受的利润损失,承担责任(即使千途已被告知该等损失的可能性亦然)。尽管本协议中可能含有相悖的规定,千途对用户承担的全部责任,无论因何原因或何种行为方式,始终不超过用户因使用千途提供的服务而支付给千途的费用(如有)。
            </p>
            <p>十二、服务的变更、中断、终止</p>
            <p>
              1、鉴于网络服务的特殊性,用户同意千途有权随时变更、中断或终止部分或全部的服务。千途变更、中断或终止的服务,千途应当在变更、中断或终止之前通知用户。
            </p>
            <p>
              2、如发生下列任何一种情形,千途有权变更、中断或终止向用户提供的免费服务或收费服务,而无需对用户或任何第三方承担任何责任:
            </p>
            <p>
              (1)
              根据法律规定用户应提交真实信息,而用户提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明;
            </p>
            <p>(2) 用户违反相关法律法规或本协议的约定;</p>
            <p>(3) 按照法律规定或有权机关的要求;</p>
            <p>(4) 出于安全的原因或其他必要的情形。</p>
            <p>十三、用户专属权利</p>
            <p>
              千途尊重他人知识产权，呼吁用户也要同样尊重知识产权。
              如果用户对他人的知识产权造成了侵害，千途将依国家法律法规的规定，或在适当的情形下，将依相关规定，删除特定内容或以至终止用户对账户的使用。
              千途尊重他人的任何权利（包括知识产权），同时也要求用户尊重他人之权利。千途在适当情况下，有权自行决定终止侵害或违反他人权利之使用者的帐号。
            </p>
            <p>
              若用户认为知识产权被侵犯，请及时向千途提供详实的举证材料，或提交《要求删除或断开链接侵权网络内容的通知》（下称“删除通知”）（“删除通知”系中华人民共和国国家版权局的示范格式，如果您不明白“删除通知”的内容，请登录中华人民共和国国家版权局查看《要求删除或断开链接侵权网络内容的通知》填写说明）。
            </p>
            <p>十四、其他</p>
            <p>
              1、千途郑重提醒用户注意本协议中免除千途责任和限制用户权利的条款,请用户仔细阅读,自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。
            </p>
            <p>
              2、本协议的效力、解释及纠纷的解决,适用于中华人民共和国法律（不含港澳台法律）。若用户和千途之间发生任何纠纷或争议,首先应友好协商解决,协商不成的,用户同意将纠纷或争议提交千途住所地有管辖权的人民法院管辖。
            </p>
            <p>
              3、如本协议的任何条款无论因何种原因无效或不具可执行性的,其余条款仍有效,对双方具有约束力。
            </p>
            <p>4、千途联系方式如下： 3298507498@qq.com</p>
          </div>
        </div>
        <a
          class="close btn-ppclose"
          href="javascript:void(0)"
          @click="loginType = 4"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show:{
      default:false,
      type: Boolean,
    }
  },
  data() {
    return {
      display: this.show,
      form: {
        phone: "",
        password: "",
        captcha: "",
      },
      //切换登录 1 免密登录 | 2 密码登录 | 3 微信登录 | 4 注册 | 5 用户协议
      loginType: 2,
      rememberMe: false,
      errPhone: false,
      errCaptcha: false,
      errPassword: false,
      errMsgPhone: "",
      toggleCaptcha: true,
      time: 60,
      disabled: true,
    };
  },
  watch: {
    form: {
      deep: true,
      handler(val) {
        this.errPhone = false;
        this.errCaptcha = false;
        this.errPassword = false;
        if (val.phone.length !== 11) {
          this.disabled = true;
          this.errPhone = true;
          this.errMsgPhone = "请输入正确的手机号";
        }
        if (this.loginType == 1 || this.loginType == 4) {
          if (val.captcha.length == 0) {
            this.disabled = true;
            this.errCaptcha = true;
          } else {
            this.disabled = false;
          }
        }
        if (this.loginType == 2 || this.loginType == 4) {
          if (val.password.length == 0) {
            this.disabled = true;
            this.errPassword = true;
          } else {
            this.disabled = false;
          }
        }
      },
    },
    show(val) {
      return this.display = val;
    },
  },
  methods: {
    //获取验证码
    handleGetCaptcha() {
      if (this.form.phone.length !== 11) {
        this.errPhone = true;
        this.errMsgPhone = " 请输入正确的手机号";
        return false;
      }
      this.toggleCaptcha = false;
      setInterval(() => {
        this.time -= 1;
      }, 1000);
      setTimeout(() => {
        this.time = 60;
        this.toggleCaptcha = true;
      }, 60000);
    },
    //登录
    handleLogin() {
      if (this.disabled) {
        return false;
      }
      console.log("login");
    },
    //切换登录类型
    handleToggleLogin(type) {
      this.loginType = type;
    },
    //忘记密码
    handleRestPassword() {},
    //注册
    handleRegister() {
      console.log("register");
    },
    // 验证手机号 验证码 密码
    handleValid() {
      //   this.errPhone = false;
      //   this.errCaptcha = false;
      //   this.errPassword = false;
      //   if (this.form.phone.length > 11 || this.form.phone.length < 11) {
      //     this.errPhone = true;
      //     this.errMsgPhone = " 请输入正确的手机号";
      //     return false;
      //   }
      //   if (this.form.phone.length == 0) {
      //     this.errPhone = true;
      //     this.errMsgPhone = "手机号不能为空";
      //     return false;
      //   }
      //   if (this.loginType == 2 || this.loginType == 4) {
      //     if (this.form.password.length == 0) {
      //       this.errPassword = true;
      //       return false;
      //     }
      //   }
      //   if (this.loginType == 1 || this.loginType == 4) {
      //     if (this.form.captcha.length == 0) {
      //       this.errCaptcha = true;
      //       return false;
      //     }
      //   }
      //   this.disabled = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.passport a {
  color: #999;
  text-decoration: none;
}
.passport p,
.passport input,
.passport button {
  margin: 0;
  padding: 0;
}
.passport .o {
  color: #f77e5e;
}
.passport input,
.passport button {
  font-size: 16px;
  font-family: "Microsoft Yahei";
}
.passport input::-webkit-input-placeholder,
.passport textarea::-webkit-input-placeholder {
  color: #aaa;
  opacity: 1;
}

.passport input:-moz-placeholder,
.passport textarea:-moz-placeholder {
  color: #aaa;
  opacity: 1;
}

.passport input::-moz-placeholder,
.passport textarea::-moz-placeholder {
  color: #aaa;
  opacity: 1;
}
.passport input:-ms-input-placeholder,
.passport textarea:-ms-input-placeholder {
  color: #aaa;
  opacity: 1;
}
.passport button:focus {
  outline: none;
}
.passport input[type="checkbox"] {
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: none !important;
  width: 18px;
  height: 18px;
  margin-right: 8px;
  background: url(/icons/check-1.png) no-repeat center;
  background-size: 100% auto;
}
.passport input[type="checkbox"]:checked {
  background: url(/icons/check-2.png) no-repeat center;
  background-size: 100% auto;
}
.passport .btn.disabled {
  background: #ccc !important;
  border: none !important;
  pointer-events: none;
  cursor: not-allowed;
}
.passport .btn-yzm.disabled {
  background: none !important;
  pointer-events: none;
  cursor: not-allowed;
  border: none !important;
}
.passport {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2147483645;
  font-size: 16px;
  font-family: "Microsoft Yahei";
  color: #333;
}
.passport a:hover {
  color: #f77e5e;
}
.passport .mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  top: 0;
}
.passport .close {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 30px;
  height: 30px;
  display: block;
  background: url(/icons/close.png) no-repeat center;
  background-size: 18px 18px;
}
.passport .ipt {
  width: 100%;
  //   height: 19px;
  //   line-height: 19px;
  padding: 8px 0;
  border: none;
  outline: 0;
  -webkit-appearance: none;
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  box-shadow: 0 0 0px 1000px white inset;
  caret-color: #f77e5e;
}
/*
.passport .item-ok:after{
	content: "";
	position: absolute;
    left: 100%;
    top: 10px;
	width: 16px;
    height: 16px;
    display: block;
	background: url(/icons/icon-2.png) no-repeat center;
	background-size: 100% 100%;
}
.passport-yzm-tem.item-ok:after{
	left: 56%;
}
*/
.passport .btn {
  background: #f77e5e;
  border: none;
  color: #fff;
  border-radius: 5px;
  width: 100%;
  min-width: inherit;
  height: 38px;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.passport .btn-reg,
.passport .btn-login,
.passport .btn-bind,
.passport .btn-save {
  height: 48px !important;
}
.passport-box {
  position: relative;
  background: #fff;
  width: 550px;
  border-radius: 6px;
  z-index: 2147483645;
}
.passport-box .hd {
  width: 100%;
  height: 70px;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
}
.passport-box .bd {
  padding: 10px 60px;
  max-height: 600px;
  overflow-y: auto;
}
.passport-box .passport-form-item {
  margin: 22px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999;
  position: relative;
}
.passport-box .passport-form-item label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.passport-box .item-c {
  justify-content: center;
  margin-top: 40px;
}
.passport-box .item-w {
  flex-direction: column;
  justify-content: center;
  margin-top: 40px;
}
.passport-box .passport-ipt-item {
  border-bottom: 1px solid #eee;
}
.passport-box .ipt-yzm {
  width: 56%;
}
.passport-box .btn-yzm {
  width: auto;
  font-size: 16px;
  background: none;
  border: none;
  color: #f77e5e;
  height: 35px;
  line-height: 35px;
  cursor: pointer;
  margin-left: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.passport .icon-weixin {
  width: 30px;
  height: 30px;
  display: inline-block;
  background: url(/icons/icon-5.png) no-repeat center;
  background-size: 100% 100%;
  margin-right: 10px;
}
.passport .weixin-login {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
}
.passport .hd-break {
  font-size: 14px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  position: relative;
  text-align: center;
  margin-bottom: 30px;
}
.passport .hd-break:after {
  content: "";
  width: 100%;
  height: 1px;
  background: #eee;
  position: absolute;
  left: 0;
  top: 10px;
  z-index: 0;
}
.passport .hd-break span {
  display: inline-block;
  padding: 0 20px;
  background: #fff;
  position: relative;
  z-index: 1;
}
.passport .bind-top {
  text-align: center;
  margin-top: 20px;
  line-height: 28px;
}
.passport .bind-top .o {
  margin: 0 5px;
}
.passport .passport-wechat-form .code {
  width: 200px;
  height: 200px;
}
.passport .icon-saoma {
  width: 38px;
  height: 38px;
  margin-right: 10px;
}
.passport .passport-wechat-form .item-c {
  margin-top: 20px;
  color: #333;
}
.passport .passport-wechat-form .passport-form-item:nth-child(3) {
  justify-content: center;
}
.toast-msg {
  background: rgba(0, 0, 0, 0.6);
  padding: 10px 20px;
  color: #fff;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2147483645;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.passport .icon-ok {
  width: 28px;
  height: 28px;
  display: inline-block;
  background: url(/icons/icon-6.png) no-repeat center;
  background-size: 100% 100%;
  margin-right: 10px;
}
.passport-form-item-error {
  font-size: 14px;
  color: #e25d46;
  height: 14px;
  line-height: 14px;
  margin: -14px 0;
  position: relative;
  padding-left: 18px;
}
.passport-form-item-error:before {
  content: "";
  width: 14px;
  height: 14px;
  display: inline-block;
  background: url(/icons/icon-1.png) no-repeat center;
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.passport-agreement-form {
  text-align: justify;
}
.passport-agreement-form p {
  margin: 10px 0;
  line-height: 22px;
  font-size: 15px;
}
/*
.passport-btn-loading{
	background: #ccc url(/icons/loading.gif) no-repeat center!important;
	background-size: 20px 20px!important;
    border: none!important;
    pointer-events: none;
    cursor: not-allowed;
	
}
*/
.passport-icon-loading {
  width: 18px;
  height: 18px;
  display: block;
  background: url(/icons/loading.gif) no-repeat center;
  background-size: 100% 100%;
  margin-right: 8px;
}

@media all and (max-width: 768px) {
  body {
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
      "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  }
  .passport inpu,
  .passport button {
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
      "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  }
  .passport a {
    color: #f77e5e;
  }
  .passport-box {
    width: 90%;
  }
  .passport .ipt {
    background: #f7f9fa;
    border: 1px solid #e6eaec;
    border-radius: 5px;
    -webkit-box-shadow: none;
    box-shadow: none;
    height: 20px;
    line-height: 20px;
    padding: 10px;
  }
  .passport-box .hd {
    height: 50px;
    box-shadow: none;
    font-size: 18px;
  }
  .passport-box .bd {
    padding: 0 20px 10px;
    max-height: 60vh;
    overflow-y: auto;
  }
  .passport-box .passport-form-item {
    margin: 15px 0;
    width: 100%;
  }
  .passport-box .passport-ipt-item {
    border-bottom: none;
    margin: 10px 0;
  }
  .passport .btn {
    font-size: 16px;
  }
  .passport-box .btn-yzm {
    width: calc(44% - 10px);
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #f77e5e;
    border-radius: 5px;
    justify-content: center;
  }
  .passport input[type="checkbox"] {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
  .passport .hd-break {
    width: 80%;
  }
  .passport .close {
    width: 32px;
    height: 32px;
    background: url(/icons/close2.png) no-repeat center;
    background-size: 100% 100%;
    right: inherit;
    top: inherit;
    left: 50%;
    bottom: -50px;
    margin-left: -16px;
  }
  .passport .hd-break {
    margin-bottom: 20px;
  }

  .passport .btn-yzm.disabled {
    background: #ccc !important;
    color: #fff;
    border: 1px solid #ccc !important;
  }
  .passport .btn-reg,
  .passport .btn-login,
  .passport .btn-bind,
  .passport .btn-save {
    height: 44px !important;
  }
  .passport .icon-ok {
    width: 20px;
    height: 20px;
  }
  .passport-form-item-error {
    margin: -4px 0;
  }
}

@media all and (max-width: 320px) {
  body {
    font-size: x-small;
  }
  .passport .btn {
    font-size: 14px;
  }
  .passport-box .btn-yzm {
    font-size: x-small;
  }
  .passport .ipt {
    font-size: x-small;
  }
  .passport inpu,
  .passport button {
    font-size: x-small;
  }
}
</style>